import { Injectable, EventEmitter } from '@angular/core';
import { FeatureCollection, Geometry } from 'geojson';
import { MapService } from 'src/app/shared/components/map/map.service';


@Injectable({
  providedIn: 'root'
})
export class ResultMapFilterService {

  private static SOURCE_NAME = 'mitra-result';

  public tags$ = new EventEmitter<string[]>();

  private collection: FeatureCollection<Geometry, { [name: string]: any; }>;
  private tags: string[] = [];

  constructor(
    private mapService: MapService
  ) { }

  setCollection(collection: FeatureCollection<Geometry, { [name: string]: any; }>) {
    this.collection = collection;
  }

  addFilter(...values: string[]) {
    values.forEach(t => this.tags.push(t));
    this.next();
    this.filter();
  }

  removeFilter(...values: string[]) {
    values.forEach(t => this.tags.splice(this.tags.indexOf(t), 1));
    this.next();
    this.filter();
  }

  clear() {
    this.tags = [];
    this.clearFilter();
    this.next();
  }

  private next() {
    this.tags$.next(Object.assign([], this.tags));
  }

  private filter() {
    if (!this.tags.length) {
      this.clearFilter();
      return;
    }

    this.mapService.map$.subscribe(m => {
      const features = this.collection.features.filter(f => {
        if (!f.properties.tags) {
          return true;
        }
        const elTags = f.properties.tags as string[];
        return !!elTags.filter(value => this.tags.includes(value)).length;
      });
      this.setDataSource(m, { type: 'FeatureCollection', features });
    });
  }

  private clearFilter() {
    this.mapService.map$.subscribe(m => {
      this.setDataSource(m, this.collection);
    });
  }

  private setDataSource(m: mapboxgl.Map, collection: FeatureCollection<Geometry, { [name: string]: any; }>) {
    this.getSource(m).setData(collection);
  }

  private getSource(m: mapboxgl.Map) {
    return m.getSource(ResultMapFilterService.SOURCE_NAME) as mapboxgl.GeoJSONSource;
  }

}
